<template>
	<div class="" @click="$sidebar.displaySidebar(false)">			
		<div class="row ">
            <div class="col-xl-8 mb-5 mb-xl-0">
                <div class="card shadow">
                   <div class="card-body">
                          <h4 class="mb-3">新規作成</h4>
                          <div>
                              <transition name="slide-fade">
                                <div class="alert alert-success" v-if="info" >{{ info }}</div>
                              </transition>

                              <div class="form-group" v-bind:class="{  'text-danger has-error': errors.name }">
                                  <label for="title">ロール名<span class="badge badge-required">必須</span></label>
                                  <input type="text" v-model="roleName" class="form-control" name="roleName" id="roleName" />
                                    <p v-for="(error,key) in errors.name" :key="key" class="error-text" >{{error}}</p>                              
                              </div>
							                <div class="form-group">
                                <label >許可<span class="badge badge-required">必須</span></label>
                                <ul  class="checkbox-container">
                                    <li class="form-check" v-for="(permission,key) in allPermissions" :key="key">
                                      <input type="checkbox"  v-model="permissionSelected" :value="permission.id" class="form-check-input"  :id="permission.name" >
									                    <label class="form-check-label" :for="permission.name">{{ permission.label_jp }}</label>
                                    </li>
                                </ul>
                                 <p v-for="(error,key) in errors.permission" :key="key" class="error-text" >{{error}}</p>
                              </div>

							                <div class="btn-wrap form-group text-center">
								                <a class="btn btn-primary" href="/roles/">戻る</a>
                                <button  class="btn btn-primary" @click="save"  :disabled="loading" >登録</button>
							                </div>

							  
<!--
							   会社名　アドレス　名前　部署　役職　電話番号　住所の変更ができる

							  "created_at":"2021-05-18T11:40:16.000000Z","updated_at":"2021-05-18T11:42:23.000000Z","company_id":1,"username":"","designation":"","is_active":1,"sys_admin":0,"first_name":"","last_name":"","dept":"","phone":""}

-->
							   
                          </div>
					          </div>
                </div>
            </div>
			
		</div>
	</div>
</template>

<script>
export default {
	props: ['permissions'],
	data() {
		return {
			// Our data object that holds the Laravel paginator data
      allPermissions: {},
      errors: {},
      roleName: '',
      permissionSelected: [],
			siteId:0,
      loading: false,
      info:null,
		}
	},

	mounted() {
		// Fetch initial results
		this.siteId = window.PushL.site_id;
		console.log(this.siteId)
    this.allPermissions = JSON.parse(this.permissions)
		
	},

	methods: {
		// Our method to GET results from a Laravel endpoint
		 save() {
      this.loading = true;
      this.isSend = 0;
      this.errors = {};
     
      axios.post('/roles', {
        name:this.roleName,
        permission: this.permissionSelected
      	//reservation_at: moment(this.reservationDate).format('YYYY-MM-DD') + " "+this.reservationHour+":"+this.reservationMinute
      }).then(response => {
        this.loading = false;
        this.$toast(response.data.info, {
          toastClassName: "toaster"
        })
        //this.info = response.data.info;
        this.resetFields();
        this.$toast("保存しました", {
          timeout: false,
          toastClassName: "toaster"
        });
        
      }).catch(error => {
        console.log(error)
        if (error.response.status === 422) {
          this.errors = error.response.data.errors || {};
           this.loading = false;
           //this.info = error.response.data.info
        } else if (error.response.status === 419) {
          alert("ページセッション切りましたので、保存できませんでした。ページをリロードしてください")
        }
      });
    },
	}

}
</script>

<style scoped>

</style>